import React from "react";


export const Input: React.FC<React.InputHTMLAttributes<HTMLInputElement>> = ({ className, ...props }) => (
    <input className={`px-3 py-2 rounded-md bg-gray-700 text-white ${className}`} {...props} />
);

export default Input;